<template>
  <div class="portal-notifications-panel" :class="{open: showNotifications}">
    <div class="panel-content">
      <button type="button" class="close float-right" aria-label="Close" @click="closeNotifications">
        <span aria-hidden="true">&times;</span>
      </button>
      <h3 class="mt-3">
        {{ $t('notifications') }}
      </h3>
      <div v-if="!notifications.length && !loadingNotifications" class="alert alert-info" role="alert">
        <p>{{ $t('portal.noNotifications') }}</p>
      </div>
      <ul v-if="notifications.length" class="list-group">
        <li v-for="notification in notifications" class="list-group-item">
          <div class="notification-message" v-html="$sanitize(linkify(notification.message))" />
          <div class="float-right">
            <span v-if="notification.send_text" class="fa fa-phone" />
            <span v-if="notification.send_email" class="fa fa-envelope" />
            <span v-if="notification.send_call" class="fa fa-phone-alt" />
          </div>
          <small class="text-muted">{{ notification.created_at | formatDate('M/d/yyyy h:mm a') }}</small>
        </li>
        <div v-if="currentPage < totalPages" class="text-center">
          <a
            class="btn btn-link"
            :class="{'btn-loading': loadingMore}"
            :disabled="loadingNotifications"
            @click="loadMoreNotifications"
          >
            {{ $t('seeMore') }}
          </a>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { format as f, parseISO } from 'date-fns';
  import linkifyStr from "linkify-string";

  export default {
    name: "Notifications",
    filters: {
      formatDate(date, format) {
        return f(parseISO(date), format);
      },
    },
    data() {
      return {
        loadingMore: false
      }
    },
    computed: mapState({
      showNotifications: 'showNotifications',
      loadingNotifications: 'loadingNotifications',
      notifications: 'notifications',
      currentPage: 'notificationPage',
      totalPages: 'notificationTotalPages'
    }),
    methods: {
      async loadMoreNotifications() {
        this.loadingMore = true;
        await this.$store.dispatch('LOAD_NOTIFICATIONS', true);
        this.loadingMore = false;
      },
      closeNotifications() {
        this.$store.dispatch('TOGGLE_NOTIFICATIONS');
      },
      linkify(message) {
        return linkifyStr(message, { target: { url: null }});
      }
    },
  }
</script>

<style scoped>
  .panel-content {
    transform: scaleX(-1)
  }

  .portal-notifications-panel {
    transform: scaleX(-1);


    width: 400px;
    height: 100%;
    padding: 50px 10px 150px 10px;
    border-left: 1px solid #ddd;
    box-shadow: none;
    background-color: #fff;

    top: 0;
    bottom:0;
    right: -400px;
    position:fixed;
    overflow-y:scroll;
    overflow-x:hidden;

    transition: right .5s ease-out, box-shadow .5s ease-out;
  }

  .portal-notifications-panel.open {
    right: 0;
    box-shadow: 0 5px 10px #ddd;
  }

  @media (max-width: 480px) {
    .portal-notifications-panel {
      width: 100%;
      right: -100%;
      max-width: 100%;
    }
  }

  .portal-notifications-panel::-webkit-scrollbar {
    width: 5px;
  }

  .portal-notifications-panel::-webkit-scrollbar-thumb {
    background: #CCC; /* make this brand color? */
  }

</style>
